import { arrays } from "@docsndata/lang-util";
import { accessory } from "./Accessory";
import { amountWithoutDecimalPlaces } from "@docsndata/stripe-cloud-functions-api/dist/esm";
function removeAvailableTimeSlotDuplicates(slots) {
    return Object.entries(slots).reduce((acc, value) => {
        acc[value[0]] = arrays.unique(value[1]);
        return acc;
    }, {});
}
const cloudFunctionRootUri = "https://europe-west2-docs-n-data.cloudfunctions.net/customEndpoint";
export function rootUri() {
    return cloudFunctionRootUri;
}
export async function loadAvailableTimeSlotsByDate(fromDateIso, toDateIso) {
    const url = `${rootUri()}/v1/thesmartwashltd.com/available?fromDate=${fromDateIso}&toDate=${toDateIso}`;
    return fetch(url).then(response => response.json()).then(removeAvailableTimeSlotDuplicates);
}
export async function loadAccessories() {
    const url = `${rootUri()}/v1/thesmartwashltd.com/allAccessories`;
    const fetchedJson = await fetch(url).then(response => response.json());
    return fetchedJson.accessories.map(fetched => accessory(fetched.iD, fetched.name, amountWithoutDecimalPlaces(fetched.price * 100)));
}
function limitToService(serviceId, prices) {
    return Object.entries(prices).reduce((acc, value) => {
        acc[value[0]] = value[1].filter(ps => ps.serviceId === serviceId);
        return acc;
    }, {});
}
export async function loadPricedServicesByByDate(fromDateIso, toDateIso, serviceId) {
    const url = `${rootUri()}/v1/thesmartwashltd.com/pricedServices?fromDate=${fromDateIso}&toDate=${toDateIso}`;
    return fetch(url).then(response => response.json()).then(prices => limitToService(serviceId, prices));
}
export async function loadAllServices() {
    const url = `${rootUri()}/v1/thesmartwashltd.com/allServices`;
    return fetch(url).then(response => response.json());
}
